import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {ThemeProvider} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import barTheme from './barTheme';
import MenuItem from './menuItem';
import List from '@material-ui/core/List'
import { withTranslation  } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
 
  link:{
    color: theme.palette.text.secondary,
    width: '100%',
  },
  title: {
    display: 'flex',
    align:"left",
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  
  input: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },

  sectionDesktop: {
  //  display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: { 
      display: 'none',
    },
  },
  appBar:{
      position:"fixed",      
      display:"flex"
  },

  list:{
   //   position:"fixed",      
      display:"flex"
  },

  toolBar:{
    //background:  '#E5EFF0', //gatsby-plugin-theme/index.js 
    //background: "#941F7A", //reedBasketTheme
   // background:  theme.primary,
   // maxWidth:"100%",
  },
}));

function LandingPageAppBar({t, i18n}) {

  const classes = useStyles();
 
  return (
    <ThemeProvider theme={barTheme}>
                 
    <div className={classes.grow}>
      
      <AppBar  className={classes.appBar} disableGutters='false'>
        <Toolbar  className={classes.toolBar} >
         
          <Typography className={classes.title} variant="h3" noWrap>
             <a href='./' className={classes.link} >
              ReedBasket        
              </a>
          </Typography>
          
           <div className={classes.grow}/>
          <List id="navigate"  className={classes.list}>
            <MenuItem text={t("Administrators")} itemName='Admin'/>
            <MenuItem text={t("Members")} itemName='Members'/>
            <MenuItem text={t("Contact us")} itemName='Contact'/>
          </List>
        </Toolbar>
      </AppBar>
    </div>
   
    </ThemeProvider>
  );
};

export default withTranslation('landing') (LandingPageAppBar)
